import { render } from "./PhysicalMetricsWindow.vue?vue&type=template&id=54d7b793"
import script from "./PhysicalMetricsWindow.vue?vue&type=script&lang=js"
export * from "./PhysicalMetricsWindow.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__